import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function AddProductDiscountForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState();
  const [formData, setFormData] = useState({
    product_id: "",
    start_date: "",
    end_date: "",
    dis_type: "",
    use_discount: "",
    discount_amount: "",
    is_offer: "no",
    specific_customers: "",
    multi_customer_id: [],
    food_menu: [],
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      [e.name]: e.value,
    });
  };

  const handleCustomerSelect = (e) => {
    const customerId = e.map((v) => v.value);
    setFormData({
      ...formData,
      multi_customer_id: customerId,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!id) {
      axios
        .post(`${apiKey}/api/rms/admin/discounts`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          toast.error(err.response.data.details, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      axios
        .put(`${apiKey}/api/rms/admin/discounts/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          toast.error(err.response.data.details, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const navigate = useNavigate();

  const discountTypes = [
    {
      label: languageHelper(defaultLang, "Amount"),
      value: "amount",
      name: "dis_type",
    },
    {
      label: languageHelper(defaultLang, "Percentage"),
      value: "percentage",
      name: "dis_type",
    },
  ];

  useEffect(() => {
    const fetchProducts = () => {
      return axios.get(`${apiKey}/api/rms/admin/foodMenus`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      });
    };

    const fetchCustomers = () => {
      return axios.get(`${apiKey}/api/rms/admin/customer`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
    };

    const fetchData = () => {
      Promise.all([fetchProducts(), fetchCustomers()])
        .then(([dataRes, customerRes]) => {
          const mappedProducts = dataRes.data.foodMenus.map((item) => ({
            label: defaultLang === "text_en" ? item.name : item.name_arabic,
            value: item.id,
            price: item.sale_price,
            name: "product_id",
          }));
          setData(mappedProducts);

          const mappedCustomers = customerRes.data.map((item) => ({
            label: item.name,
            value: item.id,
            name: "multi_customer_id",
          }));
          setCustomers(mappedCustomers);
        })
        .catch((err) => {
          setError(err);
        });
    };

    handleCSRF(fetchData);

    if (id) {
      setPageLoading(true);
      const fetchDiscount = () => {
        axios
          .get(`${apiKey}/api/rms/admin/discounts/${id}`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
            params: {
              includes: "product",
            },
          })
          .then((res) => {
            setFormData(res.data.data);
          })
          .catch((err) => {
            setError(err.response.data.message);
          })
          .finally(() => {
            setPageLoading(false);
          });
      };

      handleCSRF(fetchDiscount);
    }
  }, [id, user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper(defaultLang, "Add Product Discount")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="grid grid-cols-4 gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="col-span-2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper(defaultLang, "Product Name")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    placeholder="Select"
                    options={data}
                    defaultValue={{
                      value: formData.food_menu[0]?.id,
                      label: formData.food_menu[0]?.name,
                    }}
                    onChange={handleSelectChange}
                  />
                </div>
              </label>
              <label htmlFor="" className="col-span-2">
                <span className="text-d-bg-text text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper(defaultLang, "Discount Type")}
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    placeholder="Select"
                    options={discountTypes}
                    defaultValue={{
                      value: formData.dis_type,
                      label:
                        formData.dis_type === "percentage"
                          ? languageHelper(defaultLang, "Percentage")
                          : formData.dis_type === "amount"
                          ? languageHelper(defaultLang, "Amount")
                          : "",
                    }}
                    onChange={handleSelectChange}
                  />
                </div>
              </label>

              <label htmlFor="" className="col-span-2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper(defaultLang, "Start Date")}
                </span>
                <div className="mb-2 pt-0">
                  <div className="mb-2 pt-0">
                    <div>
                      <input
                        type="datetime-local"
                        className="p-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        placeholder=""
                        value={formData.start_date}
                        name="start_date"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </label>
              <label htmlFor="" className="col-span-2">
                <span className="text-d-bg-text text-sm mb-2  relative">
                  {languageHelper(defaultLang, "End Date")}
                </span>
                <div className="mb-2 pt-0">
                  <div>
                    <input
                      type="datetime-local"
                      className="p-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                      placeholder=""
                      name="end_date"
                      value={formData.end_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </label>

              <label htmlFor="" className="col-span-2">
                <span className="text-d-bg-text text-sm mb-2 relative">
                  {languageHelper(defaultLang, "Amount")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper(defaultLang, "Amount")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="discount_amount"
                    value={formData.discount_amount}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="" className="">
                <div className="form-check text-d-bg-text">
                  <div>
                    <h2>{languageHelper(defaultLang, "Use Discount")}</h2>
                  </div>
                  <input
                    type="radio"
                    name="use_discount"
                    id="use_discount_one"
                    value="one_time"
                    defaultChecked={formData.use_discount === "one_time"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "one_time"
                      });
                    }}
                  />
                  <label
                    className="form-check-label pe-5 ps-3"
                    htmlFor="use_discount_one"
                  >
                    {languageHelper(defaultLang, "One Time")}
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="use_discount"
                    id="use_discount_reg"
                    value="regular"
                    defaultChecked={formData.use_discount === "regular"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "regular"
                      });
                    }}
                  />
                  <label
                    className="form-check-label ps-3"
                    htmlFor="use_discount_reg"
                  >
                    {languageHelper(defaultLang, "Regular")}
                  </label>
                </div>
              </label>

              <label htmlFor="" className="">
                <div className="form-check text-d-bg-text">
                  <div>
                    <h2>{languageHelper(defaultLang, "Specific Customers")}</h2>
                  </div>
                  <input
                    type="radio"
                    name="specific_customers"
                    id="specific_customers_yes"
                    value="yes"
                    defaultChecked={formData.specific_customers === "yes"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "yes"
                      });
                    }}
                  />
                  <label
                    className="form-check-label pe-5 ps-3"
                    htmlFor="specific_customers_yes"
                  >
                    {languageHelper(defaultLang, "Yes")}
                  </label>
                  <input
                    className="ps-5"
                    type="radio"
                    name="specific_customers"
                    id="specific_customers_no"
                    value="no"
                    defaultChecked={formData.specific_customers === "no"} // Check based on value
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value, // Set the value to "no"
                      });
                    }}
                  />
                  <label
                    className="form-check-label ps-3"
                    htmlFor="specific_customers_no"
                  >
                    {languageHelper(defaultLang, "No")}
                  </label>
                </div>
              </label>
              {formData.specific_customers === "yes" && (
                <label htmlFor="" className="col-span-4">
                  <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                    {languageHelper(defaultLang, "Customers")}
                  </span>
                  <div className="mb-2 pt-0">
                    <Select
                      type="text"
                      className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                      required
                      placeholder={languageHelper(defaultLang, "Select")}
                      options={customers}
                      closeMenuOnSelect={false}
                      isMulti
                      value={customers.filter((customer) =>
                        formData.multi_customer_id.includes(customer.value)
                      )} // Map customer IDs to option objects
                      onChange={handleCustomerSelect}
                    />
                  </div>
                </label>
              )}
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper(defaultLang, "Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper(defaultLang, "Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddProductDiscountForm;
